import { Location } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouteService } from '../../../services/route.service';
import { User } from '../../../models/entities/users';
import BaseIndexPageConfig from '../base-index-page/base-index-page.config';
import { CustomButtonComponent } from "../../widgets/custom-button/custom-button.component";
import { DataTableComponent } from "../../widgets/data-table/data-table.component";
import { HttpParams } from '@angular/common/http';
import BaseDetailPageConfig from '../../../models/base-detail-page.config';
import { DataListComponent } from '../../widgets/data-list/data-list.component';
import { ActivatedRoute } from '@angular/router';


@Component({
  selector: 'base-detail-page',
  imports: [FormsModule, DataListComponent, CustomButtonComponent],
  templateUrl: './base-detail-page.component.html',
  styleUrl: './base-detail-page.component.scss'
})
export class BaseDetailPageComponent implements OnInit {

  @Input() config?: BaseDetailPageConfig;
  @Output() onLoadedDetail = new EventEmitter<any>();

  constructor(
    private route: ActivatedRoute,
    private location: Location
  ) { }

  ngOnInit(): void {

    const paramId = this.route.snapshot.paramMap.get(this.config!.routeParamName);
    console.log(`Param ID: ${paramId}`);
    
    this.loadData(paramId);

  }

  loadData(paramId: any) {
    this.config?.apiDetailService(paramId, {
    }).subscribe((response: any) => {      
      this.config!.dataList.data = response.data[this.config!.responseModelName];
      this.onLoadedDetail.emit(this.config!.dataList.data);
    });

  }

  goBack(): void {
    this.location.back();

  }
}
